/**
 * @license
 * Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
 */

import '@polymer/iron-iconset-svg/iron-iconset-svg.js';
const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = `<iron-iconset-svg name="cs-action-32" size="32" style="display: none;">
	<svg>
		<defs>
			<g id="account">
				<path d="M25,21v4H7V21c0-1.657,4.029-3,9-3s9,1.343,9,3M16,7a5,5,0,1,0,5,5,5,5,0,0,0-5-5"></path>
			</g>
			<g id="calendar">
				<path d="M10,19h5V14H10ZM26,8.111V25.889A1.111,1.111,0,0,1,24.889,27H7.111A1.111,1.111,0,0,1,6,25.889V8.111A1.111,1.111,0,0,1,7.111,7H9V5h2V7H21V5h2V7h1.889A1.111,1.111,0,0,1,26,8.111ZM8,24.785H24V12.214H8Z"></path>
			</g>
			<g id="caret-down">
				<clipPath id="a">
					<rect fill="none"></rect>
				</clipPath>
				<rect opacity="0" clip-path="url(#a)"></rect>
				<polygon points="10 13 16 19 22 13 10 13"></polygon>
			</g>
			<g id="cart">
				<path d="M22,22a2,2,0,1,0,2,2A2,2,0,0,0,22,22ZM12,22a2,2,0,1,0,2,2A2,2,0,0,0,12,22Zm.89-3.55a1.609,1.609,0,0,0-.15.53A1.2,1.2,0,0,0,13,19H23v2H13a2.13,2.13,0,0,1-2-.93,2.779,2.779,0,0,1,.07-2.52l.82-1.55L8.348,8H6V6H9a1,1,0,0,1,.91.59L13.648,15h6.77l2.86-5H13V8H25a1,1,0,0,1,.87,1.5l-4,7A1,1,0,0,1,21,17h-7.38Z"></path>
			</g>
			<g id="conversation">
				<path d="M21,7v9a1,1,0,0,1-1,1H10L6,21V7A1,1,0,0,1,7,6H20a1,1,0,0,1,1,1m4,3H23v9H10v2a1,1,0,0,0,1,1H22l4,4V11a1,1,0,0,0-1-1"></path>
			</g>
			<g id="download">
				<path d="M25,26H7a1,1,0,0,1-1-1V21H8v3H24V21h2v4A1,1,0,0,1,25,26ZM21.293,14.293,17,18.586V6H15V18.586l-4.293-4.293L9.293,15.707l6,6a1,1,0,0,0,1.414,0l6-6Z"></path>
			</g>
			<g id="grid">
				<path d="M9,23h5V18H9Zm9,0h5V18H18ZM9,14h5V9H9Zm9,0h5V9H18Z"></path>
			</g>
			<g id="list">
				<path d="M8,23h2V21H8Zm4,0H24V21H12ZM8,17h2V15H8Zm4,0H24V15H12ZM8,11h2V9H8Zm4,0H24V9H12Z"></path>
			</g>
			<g id="login">
				<path d="M18.707,16.707l-4,4-1.414-1.414L15.586,17H5V15H15.586l-2.293-2.293,1.414-1.414,4,4a1,1,0,0,1,0,1.414M27,25V7a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1v3h2V8H25V24H14V22H12v3a1,1,0,0,0,1,1H26a1,1,0,0,0,1-1"></path>
			</g>
			<g id="logout">
				<path d="M19,17H8.414l2.293,2.293L9.293,20.707l-4-4a1,1,0,0,1,0-1.414l4-4,1.414,1.414L8.414,15H19Zm8,8V7a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1v3h2V8H25V24H14V22H12v3a1,1,0,0,0,1,1H26A1,1,0,0,0,27,25Z"></path>
			</g>
			<g id="playlist-add">
				<path d="M7,22h5V20H7Zm13-5v3H17v2h3v3h2V22h3V20H22V17ZM7,16H18V14H7Zm0-6H21V8H7Z"></path>
			</g>
			<g id="redeem">
				<path d="M25.157,10H21.816A2.962,2.962,0,0,0,22,9a3,3,0,0,0-6,0,3,3,0,0,0-6,0,2.962,2.962,0,0,0,.184,1H6.843A.842.842,0,0,0,6,10.843V25.157A.842.842,0,0,0,6.843,26H25.157A.842.842,0,0,0,26,25.157V10.843A.842.842,0,0,0,25.157,10ZM19,8a1,1,0,1,1-1,1A1,1,0,0,1,19,8ZM13,8a1,1,0,1,1-1,1A1,1,0,0,1,13,8ZM24,24H8V21H24Zm0-6H8V12h4.586l-1.828,1.829,1.414,1.414L15.414,12h1.637l3.242,3.243,1.414-1.414L19.879,12H24Z"></path>
			</g>
			<g id="settings">
				<path d="M26,17.112V14.889H23.69a7.742,7.742,0,0,0-1.469-3.538l1.636-1.636L22.285,8.144,20.65,9.78a7.741,7.741,0,0,0-3.539-1.469V6H14.889V8.311A7.733,7.733,0,0,0,11.351,9.78L9.715,8.144,8.144,9.715l1.635,1.636a7.74,7.74,0,0,0-1.468,3.538H6v2.223H8.311A7.74,7.74,0,0,0,9.779,20.65L8.144,22.286l1.571,1.571,1.636-1.636a7.721,7.721,0,0,0,3.538,1.468V26h2.222V23.689a7.729,7.729,0,0,0,3.539-1.468l1.635,1.636,1.572-1.571L22.221,20.65a7.742,7.742,0,0,0,1.469-3.538Zm-5.37,1.947a5.545,5.545,0,0,1-5.741,2.385,5.593,5.593,0,0,1-4.332-4.332,5.523,5.523,0,0,1,0-2.223,5.555,5.555,0,1,1,10.073,4.17Z"></path>
			</g>
			<g id="upload">
				<path d="M25,26H7a1,1,0,0,1-1-1V21H8v3H24V21h2v4A1,1,0,0,1,25,26ZM22.707,12.293l-6-6a1,1,0,0,0-1.414,0l-6,6,1.414,1.414L15,9.414V22h2V9.414l4.293,4.293Z"></path>
			</g>
			<g id="check-icon">
				<polygon stroke-width="1" points="16 8.13 9.06 14.98 5 10.98 6.16 9.84 9.06 12.69 14.84 6.98"></polygon>
			</g>
			<g id="expand">
				<path d="M4.6,29.352h4.26v2.629H1.428A1.313,1.313,0,0,1,.114,30.667V23.234H2.742v4.26l8.625-8.625,1.858,1.859ZM30.479.236H23.045V2.864h4.327l-8.626,8.625,1.858,1.86,8.561-8.561v4.2h2.628V1.55A1.312,1.312,0,0,0,30.479.236Z"></path>
			</g>
			<g id="contract">
				<path d="M13.285,20.062v7.652H10.579V23.4L2.027,31.948.114,30.035l8.62-8.62H4.279V18.709h7.653A1.351,1.351,0,0,1,13.285,20.062ZM31.793,2.182,29.88.269l-8.62,8.62V4.5H18.554v7.653a1.352,1.352,0,0,0,1.353,1.353h7.652V10.8H23.173Z"></path>
			</g>
			<g id="zoom-minus">
				<path d="M32.008,29.85l-9.784-9.786a12.293,12.293,0,1,0-2.165,2.164l9.786,9.786Zm-19.441-8.1a9.18,9.18,0,1,1,9.18-9.18A9.189,9.189,0,0,1,12.567,21.752ZM6.606,14.259h12.24V11.2H6.606Z"></path>
			</g>
			<g id="zoom-plus">
				<path d="M32.009,29.849l-9.786-9.785a12.272,12.272,0,1,0-2.163,2.164l9.784,9.786Zm-19.443-8.1a9.18,9.18,0,1,1,9.18-9.18A9.19,9.19,0,0,1,12.566,21.75Zm5.9-7.491h-4.59v4.59h-3.06v-4.59H6.223V11.2h4.59V6.609h3.06V11.2h4.59Z"></path>
			</g>
			<g id="controls" viewBox="0 0 56.962 56.962">
				<path d="M26.634,26.634V6.309L22.4,10.546,19.782,7.933,27.175.541a1.849,1.849,0,0,1,2.613,0l7.391,7.391-2.613,2.613L30.329,6.308V26.635H32.87l17.784,0L46.417,22.4l2.613-2.613,7.391,7.391a1.849,1.849,0,0,1,0,2.613L49.029,37.18l-2.613-2.613,4.237-4.237H30.329V50.654l4.237-4.237,2.613,2.613-7.391,7.391a1.848,1.848,0,0,1-2.613,0L19.784,49.03,22.4,46.417l4.237,4.237V30.329H6.308l4.237,4.237L7.932,37.178.541,29.787a1.848,1.848,0,0,1,0-2.613l7.391-7.391L10.545,22.4,6.308,26.633Z"></path>
			</g>
			<g id="controls-disabled" viewBox="0 0 56.962 56.962">
				<path d="M26.633,6.309V24.124l3.7-3.695V6.308l4.237,4.237,2.613-2.613L29.788.541a1.849,1.849,0,0,0-2.613,0L19.782,7.933,22.4,10.546Z"></path>
				<path d="M10.545,34.565,6.308,30.328H20.429l3.694-3.695H6.308L10.545,22.4,7.932,19.783.541,27.174a1.848,1.848,0,0,0,0,2.613l7.391,7.391Z"></path>
				<path d="M30.329,50.654V31.742l-3.695,3.695V50.654L22.4,46.417,19.784,49.03l7.391,7.391a1.848,1.848,0,0,0,2.613,0l7.391-7.391-2.613-2.613Z"></path>
				<path d="M56.421,27.174,49.03,19.783,46.417,22.4l4.237,4.237H35.436l-3.695,3.7H50.653l-4.237,4.237,2.613,2.613,7.392-7.393A1.849,1.849,0,0,0,56.421,27.174Z"></path>
				<polygon style="fill:red" points="8.756 50.486 51.756 7.486 46.099 7.486 3.1 50.486 8.756 50.486"></polygon>
			</g>
		</defs>
	</svg>
</iron-iconset-svg>`;

document.head.appendChild($_documentContainer.content);
